import script from "./MessagesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessagesView.vue?vue&type=script&setup=true&lang=ts"

import "./MessagesView.vue?vue&type=style&index=0&id=703c583b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-703c583b"]])

export default __exports__